import React, { useEffect, useRef } from 'react';
import './styles/app.scss';
import './styles/auth.scss';
import ChatComponent from './components/Chat/ChatComponent';
import AuthWindow from './components/User/AuthWindow';

function App() {
  const hasLogged = useRef(false);

  useEffect(() => {
    // Log environment info on app startup (only once, even in StrictMode)
    if (!hasLogged.current) {
      const currentEnv = process.env.REACT_APP_CHAT_API_ENV || 'production';
      if (currentEnv === 'beta') {
        console.log('🚧 Running in BETA environment - using beta API');
      }
      hasLogged.current = true;
    }
  }, []);

  return (
    <div className="App">
      {/* <AuthWindow /> */}
      <ChatComponent />
    </div>
  );
}

export default App;
